/**
 * @generated SignedSource<<6d497f63098010f2b4eb5bd237ed3dff>>
 * @relayHash c5d2ac4a1537d7803281195f96d80c46
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8e3b72497ed539c6ef0e7585f8487e809a8f4bf421d724bf0347df59de7511f4

import type { ConcreteRequest } from 'relay-runtime';
export type PagesDisplayPersistenceOption = "CARDS" | "COMPACT_LIST" | "LIST" | "%future added value";
export type useHomeViewsUserPreferencesQuery$variables = Record<PropertyKey, never>;
export type useHomeViewsUserPreferencesQuery$data = {
  readonly userPreferences: {
    readonly homePagesDisplayView: PagesDisplayPersistenceOption;
  } | null;
};
export type useHomeViewsUserPreferencesQuery = {
  response: useHomeViewsUserPreferencesQuery$data;
  variables: useHomeViewsUserPreferencesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "concreteType": "UserPreferences",
    "kind": "LinkedField",
    "name": "userPreferences",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "homePagesDisplayView"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useHomeViewsUserPreferencesQuery",
    "selections": (v0/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useHomeViewsUserPreferencesQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "c5d2ac4a1537d7803281195f96d80c46",
    "id": "8e3b72497ed539c6ef0e7585f8487e809a8f4bf421d724bf0347df59de7511f4",
    "metadata": {},
    "name": "useHomeViewsUserPreferencesQuery",
    "operationKind": "query",
    "text": "query useHomeViewsUserPreferencesQuery{userPreferences{homePagesDisplayView}}"
  }
};
})();

(node as any).hash = "a460b0b4084b80e4445d972d6b5860d1";

export default node;
